// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupHeader__container-bb3b17 {
  height: 56px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid var(--base-30);
  position: relative;
}

.PopupHeader__title-a11efa {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
}

.PopupHeader__control-ae1f4b {
  position: absolute;
  inset-inline-end: 15px;
}

.PopupHeader__copy-bc5a77 {
  margin-inline-end: 16px;
}

.PopupHeader__arrow-block-e8b07d {
  position: absolute;
  inset-inline-start: 15px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/StickerPackPopup/PopupHeader/PopupHeader.style.m.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;AACF","sourcesContent":[".container {\n  height: 56px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0 20px;\n  border-bottom: 1px solid var(--base-30);\n  position: relative;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n}\n\n.control {\n  position: absolute;\n  inset-inline-end: 15px;\n}\n\n.copy {\n  margin-inline-end: 16px;\n}\n\n.arrow-block {\n  position: absolute;\n  inset-inline-start: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopupHeader__container-bb3b17`,
	"title": `PopupHeader__title-a11efa`,
	"control": `PopupHeader__control-ae1f4b`,
	"copy": `PopupHeader__copy-bc5a77`,
	"arrow-block": `PopupHeader__arrow-block-e8b07d`,
	"arrowBlock": `PopupHeader__arrow-block-e8b07d`
};
module.exports = ___CSS_LOADER_EXPORT___;
